export default __webpack_public_path__ + "media/images/favicon-a34a7465.ico";